import React, { useEffect, useState }  from "react";
// import Helmet from "../component/common/Helmet";
import {Helmet} from 'react-helmet'
import { isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";
import DataAccessDialog from "./DataAccessDialog";
import { useHistory } from "react-router-dom";

const DataAccessPage = () => {
  const { t, i18n } = useTranslation();
  const icon = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive.webp`;
  const dandelion = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-ecoshift-eco-dandelion.webp`;
  const history = useHistory();

 // Toggle open/close of dialog
  const toggleDialog = () => {
    setShowDialog((prev) => !prev);
    // Redirect tm main page
    history.push(process.env.PUBLIC_URL);
  };

  // Handle send message action
  const handleSendMessage = (message) => {
    console.log("Message sent:", message);
    // You can call an API or update state here
    toggleDialog(); // Close dialog after sending
  };

  window.onload = function () {
    // Code runs after full page load
    console.log("Page fully loaded!");
    const purpose = document.getElementById("purpose");
    if (purpose) {
      purpose.style.opacity = 0;
    }
  };

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // trigger fade-in after mount
    const timer = setTimeout(() => {
      setVisible(true)
      setShowDialog(true)
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const info = queryParams.get("info");

  const [showDialog, setShowDialog] = useState(false);


  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
              <title>Data request</title>
              <meta name="description" content="EcoShift ⁕ the digital platform for your eco-positive consumption!" />
              <meta name="keywords" content= "ecoshift,shift,impact,transition,eco,friendly,consumption,eco-positive,sustainability,biodiversity,ecoresponsible,nature,onboarding,governance,seat,voice,voting,rights,planet,boundaries" />
              <meta property="og:title" content="Data request" />
              <meta property="og:description" content="EcoShift ⁕ the digital platform for your eco-positive consumption!" />
              <meta property="og:image" content={icon} />
              <meta property="og:url" content={process.env.PUBLIC_URL + "/"} />
              <meta name="twitter:card" content={icon} />
              <meta name="robots" content="index, follow"/>
              <link rel="canonical" href="https://ecoshift.eco/data-request" />
            </Helmet>

      {/* Start Slider Area   */}
      <div className="">
        <div
          id="home"
          className="bg_home"
          style={
            isMobile
              ? {}
              : {
                  backgroundImage: `url(${dandelion}), linear-gradient(to right, #1466cc, #fff)`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center right",
                }
          }
        >
          <div className="slider-wrapper">
            {/* Start Single Slide */}
            <div className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center">
              {isMobile ? (
                <div className="container">
                  <table style={{ border: "none", borderCollapse: "collapse" }}>
                    <tr>
                      <td
                        style={{
                          width: "50%",
                          border: "none",
                          borderCollapse: "collapse",
                        }}
                      >
                        <img
                          id="logo"
                          className=""
                          src={icon}
                          width="160px"
                          alt='ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive'
                        />
                      </td>
                      <td
                        style={{
                          width: "50%",
                          border: "none",
                          borderCollapse: "collapse",
                        }}
                      >
                        <img
                          id="dandelion"
                          className=""
                          src={dandelion}
                          alt= 'ecoshift-ecoshift-eco-dandelion'
                        />
                      </td>
                    </tr>
                  </table>

                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <div className="align-vertical align-items-center">
                        <p
                          id="purpose"
                          className="content-title"
                          style={{ color: "#fff",
                            opacity: visible ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
                           }}
                        >
                          {t("Slogan")}
                        </p>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="align-vertical align-items-center">
                        <img
                          id="logo"
                          className=""
                          height={256}
                          src={icon}
                          alt='ecoshift-logo-brand-eco-movement-ecoresponsible-ecopositive'
                        />
                        <br />
                        <br />
                        <p
                          id="purpose"
                          className="content-title23"
                          style={{ color: "#fff",
                            opacity: visible ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
                           }}
                        >
                          {t("Slogan")}
                        </p>
                        <br />
                      </div>
                    </div>
                    <div className="col-lg-6"></div>
                  </div>
                </div>
              )}
            </div>
            {/* End Single Slide */}
          </div>
        </div>
      </div>
      {/* End Slider Area   */}

{showDialog ?
                    <DataAccessDialog
                      isOpen={showDialog}
                      onClose={toggleDialog}
                      handleSendMessage={handleSendMessage}
                    />
                    : <div/>}


    </div>
  );
};

export default DataAccessPage;
